import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';

interface Props {
  display: boolean | false;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CautionDialog',
  props: {
    display: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const dialog = ref(props.display);

const setDisplay = () => {
  dialog.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "caution-dialog-title" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" 会員登録にあたり、以下の点についてご確認をお願いいたします ")
            ])),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("p", null, " ChemPandaは、掲載する製品の中から、在庫試薬・合成用試薬やバルク製品（開発品・商業品）などを直接ご使用になるお客様のご利用をお願いいたします。 ", -1),
              _createElementVNode("p", null, [
                _createTextVNode(" フリーメール等のご登録もお断りいたします。"),
                _createElementVNode("br"),
                _createTextVNode(" (使用不可例 ： xxxxx@yahoo.co.jp, xxxxx@gmail.com)"),
                _createElementVNode("br"),
                _createTextVNode(" 所属企業・機関のドメインのメールアドレスをご使用ください。"),
                _createElementVNode("br")
              ], -1)
            ])),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { align: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                color: "primary",
                label: "OK",
                style: {"width":"220px"},
                onClick: setDisplay
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})